import { render, staticRenderFns } from "./OrbitView.vue?vue&type=template&id=392cd164&scoped=true"
import script from "./OrbitView.vue?vue&type=script&lang=ts"
export * from "./OrbitView.vue?vue&type=script&lang=ts"
import style0 from "./OrbitView.vue?vue&type=style&index=0&id=392cd164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392cd164",
  null
  
)

export default component.exports